// Generated by genversion.
export const version = '0.40.0';
